export default __webpack_public_path__ + "static/media/base.627d2fe6.svg";